import React from "react";
import { CategoriasItemDetalle } from "./CategoriasItemDetalle";

function CategoriasItem(props) {
  const displayItems = (props) => {
    const categorias = props.categorias

    if (categorias.length > 0) {
      return categorias.map((categoria, index) => {
        return <CategoriasItemDetalle key={index} categoria={categoria} deleteCategoria={props.deleteCategoria} />
      })
    } else {
      return <h3>No hay categorias</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {CategoriasItem}